import { render } from "./NumberChange.vue?vue&type=template&id=6aa4cdf2&ts=true"
import script from "./NumberChange.vue?vue&type=script&lang=ts"
export * from "./NumberChange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__